"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmoothScroll = void 0;

var _react = _interopRequireWildcard(require("react"));

var _all = require("gsap/all");

var _styles = require("./styles");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

_all.gsap.registerPlugin(_all.ScrollTrigger);

var GalleryItem = function GalleryItem(_ref) {
  var index = _ref.index,
      src = _ref.src,
      srcSet = _ref.srcSet;
  var isEven = index % 2;
  var tlRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var imageRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    tlRef.current = _all.gsap.timeline({}).to(imageRef.current, {
      scale: 1.35,
      ease: 'power2.easeInOut',
      scrollTrigger: {
        trigger: containerRef.current,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    });
  }, []);
  return _react.default.createElement(_styles.ImageContainer, {
    ref: containerRef,
    isEven: isEven
  }, _react.default.createElement(_styles.ImageWrapper, null, _react.default.createElement(_styles.Image, {
    ref: imageRef,
    src: src,
    srcSet: srcSet,
    alt: src
  })));
};

var SmoothScroll = function SmoothScroll(_ref2) {
  var items = _ref2.items;
  return _react.default.createElement("div", null, items.map(function (item, index) {
    return _react.default.createElement(GalleryItem, _extends({
      key: "smooth-scroll-item--".concat(index),
      index: index
    }, item));
  }));
};

exports.SmoothScroll = SmoothScroll;